export function initHamburgerMenu() {
  const hamburgerBtn = document.querySelectorAll('.js-hamburger')[0];
  const body = document.body;
  const activeHamburgerClass = 'm-active_nav';

  // TODO: add optimizations to init only on tablets/mobiles

  if (hamburgerBtn) {
    hamburgerBtn.addEventListener('click', () => {
      body.classList.toggle(activeHamburgerClass);
    })
  }
}

export function initHamburgerAccordion() {
  const body = document.body;
  const menuItemsWithChildren = document.querySelectorAll('.b-nav-menu > .menu-item-has-children');

  const activeMenuItemClass = 'm-active';

  if (!menuItemsWithChildren.length) {
    return;
  }

  menuItemsWithChildren.forEach((menuItem) => {
    menuItem.addEventListener('click', (event) => {
      if (!body.classList.contains('m-active_nav')) {
        return false;
      }

      if (event.target === event.currentTarget) {
        menuItem.classList.toggle(activeMenuItemClass);
      }
    });
  })
}
